<template>
  <q-menu
    class="!tw-shadow-lg"
    v-bind="$attrs"
    transition-show="jump-down"
    transition-hide="jump-up"
  >
    <slot />

    <q-list v-if="listItems.length" dense v-bind="listOptions">
      <q-item
        v-for="item in listItems"
        clickable
        v-close-popup
        :to="item?.to && item.to"
        @click="item.onClick && item.onClick()"
      >
        <q-item-section>{{ item.label }}</q-item-section>
      </q-item>
    </q-list>
  </q-menu>
</template>

<script setup>
defineProps({
  listOptions: {
    type: Object,
    required: false,
  },
  listItems: {
    type: Array,
    required: false,
    default: () => [],
  },
});
</script>

<style lang="scss">
.q-list {
  @apply tw-py-2;

  &.q-list--dense > .q-item,
  .q-item--dense {
    min-height: 38px;
  }
}

div.q-menu {
  @apply tw-overscroll-contain;
}
</style>
